<template>
  <div class="carousel-wrapper">
    <div class="carousel-container" :style="{minWidth: carouselWidth}">
      <div
        class="carousel"
        ref="carousel"
        v-if="fullProductList.length > 3" 
        :style="{ transform: `translateX(-${currentIndex * (100 / visibleItems)}%)` ,
          width: carouselWidth
        }"
      >
        <div class="carousel-item"
          v-for="(item, index) in fullProductList"
          :key="index"
          @click="setCurrentIndex(item.id, item.applyProductId, index, item.productInfo.storeId)"
          :class="{ highlighted: highlightedIndex === index }"
          :style="{ minWidth: itemMinWidth }">
          <img :src="item.applyProductCover" alt="Ad" v-if="item.applyProductCover" /> 
          <div class="detail">
            <span style="font-weight: bolder;">
              <span style="font-size: 14px;">¥{{ item.productInfo.productSellPrice }}</span>
              <span style="color: gray;"> / {{ item.productInfo.productUnit }}</span>
            </span><br/>
            <span style="font-weight: bold; color: gray; display: inline-block; width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              <span style="font-size: 14px; color: black;">{{ item.productInfo.productName }}</span>
            </span>
          </div>
        </div>
      </div>
      <div
        v-else 
        class="carousel-item"
        v-for="(item, index) in fullProductList"
        :key="index"
        @click="setCurrentIndex(index)"
        :class="{ highlighted: highlightedIndex === index }"
        :style="{ minWidth: itemMinWidth }">
        <img :src="item.image" alt="Ad" v-if="item.image" />
        <div class="detail">
          <span style="font-weight: bolder;">
            <span style="font-size: 14px;">¥{{ item.productInfo.productSellPrice }}</span>
            <span style="color: gray;"> / {{ item.productInfo.productUnit }}</span>
          </span><br/>
          <span style="font-weight: bold; color: gray; display: inline-block; width: 80%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            <span style="font-size: 14px; color: black;">{{ item.applyProductName }}</span>
          </span>
        </div>
      </div>
      <button class="carousel-button left" v-if="productList.length > 3" @click="handleButtonClick">❮</button>
      <button class="carousel-button right" v-if="productList.length > 3" @click="moveToNext">❯</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarouselComponent',
  props: {
    visibleItems: {
      type: Number,
      default: 3,
      receivedData: [],
    },
    productList: {
      type: Array,
      required: true
    },
    storeId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      isDragging: false,
      startX: 0,
      currentX: 0,
      loading: false,
      clickCount: 0, // 点击计数器
      lastClickedIndex: null, // 上一次点击的项目索引
      clickThreshold: 1, // 设置点击次数达到多少进行跳转
      carouselData: null,
      highlightedIndex: null,
      isButtonClickable: true, // 控制按钮是否可点击
    };
  },
  watch:{
    $route(to, from) {
      let that = this
      console.log('watch route....')
      // 监听相同路由下参数变化的时候，从而实现异步刷新
      // 重新获取数据
      if (this.gotoId > 0) {
        console.log('watch route.... gotoId:', that.gotoId)
        history.go(0)
        this.gotoProductDetail(this.gotoId, 1)
        // window.location.href='salesDetails?id='+this.goodsId
      }
    }
  },
  computed: {
    fullProductList() {
      if (this.productList.length === 0) return [];
      // 复制原始产品列表
      const lastItem = this.productList[this.productList.length - 3];
      const secondLastItem = this.productList[this.productList.length - 2];
      const ThirdLastItem = this.productList[this.productList.length - 1];
      const firstItem = this.productList[0]; // 第一张
      const secondItem = this.productList[1]; // 第二张
      const thirdItem = this.productList[2]; // 第三张
      return [
        lastItem, // 添加最后一张
        secondLastItem, // 添加倒数第二张
        ThirdLastItem,
        ...this.productList,
        firstItem, // 添加第一张
        secondItem, // 添加第二张
        thirdItem, // 添加第三张
      ];
  },
    //过滤一下数据
    displayItems() {
    // 当项目小于3个时，直接返回所有项目
    if (this.productList.length <= 3) {
      return this.productList;
    }
    // 其他逻辑
    return [...this.productList];
  },
    carouselWidth() {
      return `${ this.visibleItems * (100/this.visibleItems)}%`;
    },
    itemMinWidth() {
      return `${100 / this.visibleItems}%`;
    }
  },
  mounted() {  
    // //初始化
    this.currentIndex = 3;  
  },
  methods: {
    //跳转到展品详情页
    gotoProductDetail(carouselId,produceId, productShowType,sid) {
      this.gotoId = produceId
      console.log("hhhhhh");
      
      console.log("sid:"+sid);
      
      this.$router.push({
        path: '/SalesDetails2',
        query: {
          carouselId: carouselId,
          id: produceId,
          productShowType: 1,
          storeId: sid
        }
      });
    },
    next() {
      if (this.currentIndex < this.fullProductList.length - 2) {  
        this.currentIndex++;
      } else { 
        console.log(cu);
        
        this.$refs.carousel.style.transition = 'none';
        setTimeout(() => {
          // 恢复过渡效果
          this.$refs.carousel.style.transition = 'transform 0.5s ease-in-out';
        }, 350); 
        this.currentIndex = 3;
      }
    },
    prev() {
      if (this.currentIndex > 1) {     
        this.currentIndex--;
      } else {
        console.log(this.currentIndex);
        
        this.currentIndex = this.fullProductList.length - 1; 
      }
    },
    moveToNext() {
      if (!this.isButtonClickable) return; // 如果按钮不可点击，直接返回
      this.isButtonClickable = false; // 设置按钮为不可点击
      this.setCurrentIndex(-1, -1, this.currentIndex + 2);
      
      // 设置定时器，0.3秒后重新允许点击
      setTimeout(() => {
        this.isButtonClickable = true; // 重新允许点击
      }, 350);
      this.resetClickCount();
    },
    handleButtonClick() {
      if (!this.isButtonClickable) return; // 如果按钮不可点击，直接返回
      this.isButtonClickable = false; // 设置按钮为不可点击
      this.setCurrentIndex(-1, -1, this.currentIndex);

      // 设置定时器，0.3秒后重新允许点击
      setTimeout(() => {
        this.isButtonClickable = true; // 重新允许点击
      }, 350);

      this.resetClickCount();
    },
    setCurrentIndex(nid,id,index, sid) {
      if (index === 0) {
        this.$refs.carousel.style.transition = 'none';
        this.currentIndex = this.fullProductList.length - 6; // 设置为目标索引
        this.highlightedIndex = index; 
        // 立即触发一次 DOM 更新，等待 0.5 秒后再启用过渡
        setTimeout(() => {
          this.$refs.carousel.style.transition = 'transform 0.35s ease-in-out';
        }, 350); // 等待 0.5 秒

        return; // 直接返回，跳过后续逻辑
      }

      if (index === this.fullProductList.length - 1) {
        this.$refs.carousel.style.transition = 'none';
        this.currentIndex = 3; // 设置为目标索引
        this.highlightedIndex = index; // 更新高亮索引

        setTimeout(() => {
          // 恢复过渡效果
          this.$refs.carousel.style.transition = 'transform 0.35s ease-in-out';
        }, 350); 

        return; // 直接返回，跳过后续逻辑
      }

      if (index === this.lastClickedIndex) {
        this.clickCount++; // 累加点击计数
        // 如果计数达到阈值，跳转到对应链接
        if (this.clickCount >= this.clickThreshold) {
          const carouselId = nid;
          const produceId = id; 
          const productShowType = 1; // 根据需要设置
          this.gotoProductDetail(carouselId,produceId, productShowType ,sid);
          this.resetClickCount();
        }
      } else {
        // 点击了不同的项目，重置计数器
        this.resetClickCount();
        this.lastClickedIndex = index; 
      }
      // 更新高亮索引
      if (index === 0) {
        this.highlightedIndex = 0;
        this.currentIndex = 0; 
      } else if (index === this.fullProductList.length) {
        this.highlightedIndex = this.fullProductList.length - 1;
        this.currentIndex = this.fullProductList.length - 3;         
      } else {
        this.highlightedIndex = index;
        this.currentIndex = index - 1; 
        
      }
    },
    resetClickCount() {
      this.clickCount = 0; 
      this.lastClickedIndex = null; 
    },
    startDrag(event) {
      this.isDragging = true;
      this.startX = event.clientX || event.touches[0].clientX;
      // this.stopAutoSlide();
    },

    onDrag(event) {
      if (!this.isDragging) return;
      this.currentX = event.clientX || event.touches[0].clientX;
      const translateX = this.currentX - this.startX;
      this.$refs.carousel.style.transform = `translateX(${translateX - this.currentIndex * (100 / this.visibleItems)}%)`;
    },
  },
  beforeDestroy() {
  },
};
</script>

<style>
.carousel-wrapper {
  overflow: hidden;
  width: 94%;
  margin-left: 3%;
  padding-bottom: 28px;
  padding-top: 22px; /* 顶部留白 */
  border-radius: 10px; /* 可选：圆角 */
}
.carousel-container {
  overflow: hidden;
  width: 90%;
  display: flex;
  justify-content: center;
  position: relative; 
  height: auto; /* 不设置具体高度了 */
  /* align-items: center; */
}

.carousel {
  display: flex;
  transition: transform 0.35s ease-in-out;
}

.carousel-item {
  box-sizing: border-box;
  padding: 10px;
  text-align: center;
  max-width: 300px;
}

.carousel-item:hover {
  transform: scale(1.1); 
}

.carousel-item img {
  width: 100%;
  aspect-ratio: 1; 
  box-sizing: border-box;
  padding: 10px;
  text-align: center;
  display: flex; 
  flex-direction: column; 
  justify-content: center; 
  border-radius: 20px;
}

.detail {
  font-size: 22px;
  background-color: rgb(239, 252, 252);
  border-radius: 6px;
  padding: 6px;
}

.carousel-button {
  width: 50px;
  position: absolute;
  top: calc(44%);
  transform: translateY(-50%);
  background-color: rgba(118, 121, 134, 0.7);
  border: none;
  cursor: pointer;
  font-size: 44px;
  padding: 10px;
  z-index: 1;
  opacity: 0.7;
  border-radius: 16px;
}

.carousel-button.left {
  left: 10px;
}

.carousel-button.right {
  right: 10px;
}

</style>


// WEBPACK FOOTER //
// src/pages/scan/components/CarouselComponent.vue